import React from "react";
import { useObserver } from "mobx-react-lite";
import { makeStyles } from "@material-ui/core/styles";
import { SaveAlt as SaveAltIcon } from "@material-ui/icons";
import { Formatter } from "libs";
import { Dialog, Table } from "components";
import { useAuthStore } from "stores/AuthStore";
import { useChurnSegmentStore } from "./ChurnSegmentStore";
import { useChurnSegmentFormStore } from "./ChurnSegmentFormStore";
import ChurnSegmentForm from "./ChurnSegmentForm";

const useStyles = makeStyles((theme) => ({
  table: {
    "& .MuiPaper-root": {
      boxShadow: "none",
    },
  },
  icon: {
    color: theme.palette.text.primary,
  },
}));

interface Props {
  className?: string;
  agencyId: number;
  appId: number;
}

export default ({ className, agencyId, appId }: Props) => {
  const authStore = useAuthStore();
  const store = useChurnSegmentStore();
  const formStore = useChurnSegmentFormStore();
  const styles = useStyles();

  React.useEffect(() => {
    store.fetchChurnSegment(agencyId, appId);
  }, [agencyId, appId, store]);

  const open = React.useCallback(() => formStore.modal(true), [formStore]);
  const close = React.useCallback(() => formStore.modal(false), [formStore]);

  return useObserver(() => (
    <Table
      className={[className, styles.table].join(" ")}
      title={
        <>
          {authStore.admin() && (
            <Dialog open={formStore.dialog} onOpen={open} onClose={close}>
              <ChurnSegmentForm agencyId={agencyId} appId={appId} />
            </Dialog>
          )}
        </>
      }
      isLoading={store.loading}
      options={{
        exportFileName: "セグメント",
      }}
      data={store.churnSegments.map((churnSegment) => ({
        ...churnSegment,
        period: `${Formatter.date(churnSegment.startAt)} ~ ${Formatter.date(
          churnSegment.endAt
        )}`,
      }))}
      columns={[
        { title: "名前", field: "name" },
        {
          title: "予測割合",
          field: "deliveryRate",
          render: (churnSegment) => 110 - 100 * churnSegment.deliveryRate,
        },
        { title: "配信期間", field: "period" },
      ]}
      actions={[
        {
          icon: "edit",
          tooltip: "編集",
          onClick: (_, churnSegment) =>
            !Array.isArray(churnSegment) &&
            formStore.modal(true, {
              id: churnSegment.id,
              twitterUserId: churnSegment.twitterUserId,
              twitterSegmentId: churnSegment.twitterSegmentId,
              name: churnSegment.name,
              predictionRate: 110 - 100 * churnSegment.deliveryRate,
              startAt: Formatter.date(churnSegment.startAt),
              endAt: Formatter.date(churnSegment.endAt),
            }),
        },
        (churnSegment) => ({
          hidden: !authStore.admin() || !churnSegment.downloadUrl,
          icon: () => (
            <a className={styles.icon} download href={churnSegment.downloadUrl}>
              <SaveAltIcon />
            </a>
          ),
          tooltip: `更新日時 : ${Formatter.date(
            churnSegment.extractedAt,
            "yyyy-MM-dd HH:mm:ss"
          )}`,
          onClick: () => null,
        }),
      ]}
    />
  ));
};
